import { hstack } from '@onbeam/styled-system/patterns';

export const footerStyle = hstack({
  align: 'center',
  gap: '4',
  px: '4',
  pb: '4',
});
